import FontAwesome5 from '@expo/vector-icons/FontAwesome5';
import {
  useResponsiveFontSize,
  useResponsiveHeight,
  useResponsiveWidth,
} from '@/components/Util/reactResponsiveDimensions';
import { useCallback, useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import colors from '@/config/colors';
import { SpeakingHeader } from '@/components/SpeakingExercise/SpeakingHeader';
import { PressableNeolexon } from '@/components/PressableNeolexon';

export function OpenReading({
  questionText,
  openQuestionAnswer,
  questionIndex,
}) {
  // const { bottom, top } = useSafeAreaInsets();
  // const verticalSafeAreaInsets = top + bottom;
  const responsiveIconSize = useResponsiveFontSize(1.5);
  const [isSolVisible, setisSolVisible] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [uriExists, setUriExists] = useState(false);

  const responsiveStyles = StyleSheet.create({
    container: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      // height: useResponsiveHeight(62) - verticalSafeAreaInsets,
      height: '100%',
      width: '100%',
    },
    textSize: {
      // fontSize: useResponsiveFontSize(2.2),
      // marginBottom: useResponsiveHeight(3),
      // textAlign: 'center',
      fontSize: useResponsiveFontSize(2),
      marginRight: useResponsiveHeight(1),
      textAlign: 'center',
    },
    audioBtns: {
      // marginVertical: useResponsiveHeight(3),
      marginVertical: useResponsiveHeight(1),
      flexDirection: 'row',
      alignItems: 'center',
    },
    btnTextSize: {
      fontSize: useResponsiveFontSize(2),
      marginLeft: useResponsiveWidth(1),
    },
    btn: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      paddingVertical: useResponsiveHeight(1.5),
      paddingHorizontal: useResponsiveWidth(1),
      backgroundColor: colors.white,
      shadowColor: '#000',
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.23,
      shadowRadius: 2.62,
      elevation: 4,
    },
    solutionContainer: {
      paddingVertical: useResponsiveHeight(1.5),
      paddingHorizontal: useResponsiveWidth(1),
      backgroundColor: colors.lightGrey,
    },
    disabled: {
      opacity: 0.4,
    },
  });

  const handleIsRecording = useCallback((value) => {
    if (value && !uriExists) {
      setUriExists(true);
    }
    setIsRecording(value);
  }, []);
  const handleLosungPress = useCallback(() => {
    setisSolVisible(true);
  }, []);

  useEffect(() => {
    setisSolVisible(false);
    setUriExists(false);
  }, [questionIndex]);

  return (
    <View style={responsiveStyles.container}>
      <Text style={responsiveStyles.textSize}>{questionText}</Text>
      <View style={responsiveStyles.audioBtns}>
        <Text style={responsiveStyles.textSize}>Ihre Antwort:</Text>
        <SpeakingHeader
          timeoutSeconds={15000}
          currentExercise={questionIndex}
          selectedPerformance={'none'}
          handleIsRecording={handleIsRecording}
        />
      </View>
      {isSolVisible ? (
        <View style={responsiveStyles.solutionContainer}>
          <Text style={responsiveStyles.btnTextSize}>
            Lösung: {openQuestionAnswer}
          </Text>
        </View>
      ) : (
        <PressableNeolexon
          onPress={handleLosungPress}
          style={[
            responsiveStyles.btn,
            (!uriExists || isRecording) && responsiveStyles.disabled,
          ]}
          disabled={!uriExists || isRecording}
        >
          <FontAwesome5
            name="eye"
            size={responsiveIconSize}
            color={colors.primary}
          />
          <Text style={responsiveStyles.btnTextSize}>Lösung</Text>
        </PressableNeolexon>
      )}
    </View>
  );
}
